'use strict';

(function () {
  'use strict';

  angular.module('vnext').service('uploadImageSvc', uploadImageSvc);

  uploadImageSvc.$inject = ['httpSvc', '$translate', 'alertSvc'];

  /* @ngInject */
  //TODO - Fix httpSvc to accomodate this type of POST with form data
  function uploadImageSvc(httpSvc, $translate, alertSvc) {
    return {
      upload: upload
    };

    ////////////////

    function upload(file, filename) {
      var validExtensions = ['jpg', 'jpeg', 'png', 'gif'];
      if (file.size > 11000000) {
        return alertSvc.error($translate.instant('vnext.inspirations.upload.error1'));
      }
      var extension = filename && filename.indexOf('.') ? filename.split('.').pop().toLowerCase() : '';
      if (!_.includes(validExtensions, extension)) {
        return alertSvc.error($translate.instant('vnext.inspirations.upload.error2'));
      }
      var fd = new FormData();
      fd.append('file', file);
      fd.append('extension', extension);
      return httpSvc.post('/apiproxy/user/communityinspirations/image', fd, {
        data: fd,
        withCredentials: true,
        headers: {
          'Content-Type': undefined
        }
      });
    }
  }
})();